<template>
  <v-container fluid>
    <v-container style="overflow: auto; max-height: 400">
      <v-btn
        v-if="
          logueado.cargo === 'Coordinador Investigador' ||
          logueado.cargo === 'Investigador' ||
          logueado.cargo === 'Administrador'
        "
        center
        @click="BloquearChat"
        title="Liberar Dibujante"
        :loading="loading"
        color="primary"
        dark
        ><v-icon dark>mdi-block-helper</v-icon>
        {{ datosCaso.chat_dibujante ? "Bloquear" : "Desbloquear" }} Chat
      </v-btn>
    </v-container>
    <vue-advanced-chat
      :current-user-id="currentUserId"
      :username-options="JSON.stringify(cantUsuario)"
      :rooms="JSON.stringify(rooms)"
      :messages="JSON.stringify(messages)"
      :messages-loaded="messagesLoaded"
      :rooms-loaded="true"
      :show-audio="false"
      :show-search="false"
      :show-add-room="false"
      :single-room="isMobile"
      :show-footer="true"
      @open-file="openFile($event.detail[0])"
      @fetch-messages="buscarMensajes($event.detail[0])"
      @send-message="sendMessage($event.detail[0])"
    />
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { db, ref, storage, uploadBytes, getDownloadURL } from "../../firebase";
// import { db } from "../../firebase";
import moment from "moment";
import { saveAs } from "file-saver";
// import ChatWindow from "vue-advanced-chat";
// import "vue-advanced-chat/dist/vue-advanced-chat.css";
import { register } from "vue-advanced-chat";
register();

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "MensajeDibujante",
  async mounted() {
    if (localStorage.getItem("user")) {
      this.currentUserId = this.logueado.id;
      if (this.logueado.cargo == "Perito") {
        this.newMensaje.avatar =
          "https://firebasestorage.googleapis.com/v0/b/servdigipats.appspot.com/o/foto-perfil%2Fabogado.png?alt=media&token=fb33caa0-bd95-42b9-b5e7-f68c7787bb8a";
      } else if (this.logueado.cargo == "Investigador") {
        this.newMensaje.avatar =
          "https://firebasestorage.googleapis.com/v0/b/servdigipats.appspot.com/o/foto-perfil%2Finvestigador.jpg?alt=media&token=f4e45f88-533c-43b4-9ff7-6facdd0456ea";
      } else if (this.logueado.cargo == "Dibujante") {
        this.newMensaje.avatar =
          "https://firebasestorage.googleapis.com/v0/b/servdigipats.appspot.com/o/foto-perfil%2Finvestigador.jpg?alt=media&token=f4e45f88-533c-43b4-9ff7-6facdd0456ea";
      } else {
        this.newMensaje.avatar =
          "https://firebasestorage.googleapis.com/v0/b/servdigipats.appspot.com/o/foto-perfil%2Fcall-center.png?alt=media&token=bb40e74f-9b28-4bd8-b4b5-6daf3d9353b6";
      }
    }
    await this.buscarSala();
  },
  data() {
    return {
      loading: false,
      users: [],
      cantUsuario: { minUsers: 2, currentUser: false },
      messagesLoaded: false,
      currentUserId: "",
      idCaso: this.$route.params.id,
      idchat: "",
      rooms: [],
      roomId: 1,
      messages: [],
      newMensaje: {
        _id: "",
        indexId: "",
        senderId: "",
        username: "Calvo",
        avatar:
          "https://firebasestorage.googleapis.com/v0/b/servdigipats.appspot.com/o/foto-perfil%2Fcliente.jpg?alt=media&token=b294ad63-36d5-4e9a-ab44-afa5a1ee8f31",
        date: moment().format("DD/MM/YYYY HH:mm", Date.now()),
        timestamp: moment().format("DD/MM/YYYY HH:mm", Date.now()),
        system: false,
        saved: true,
        distributed: true,
        seen: true,
        deleted: false,
        disableActions: false,
        disableReactions: false,
        failure: false,
        content: "",
        roomId: "",
      },
      nameArchivo: "",
      usersTokenPush: [],
      mensajeChat: "",
      datosCaso: {},
      estadoAgente: "",
      intento: 1,
    };
  },
  async created() {
    try {
      await db
        .collection("casos")
        .doc(this.idCaso)
        .onSnapshot((doc) => (this.datosCaso = doc.data()));
    } catch (error) {
      this.handleError(error);
    }
  },
  computed: {
    ...mapState(["drawer", "logueado"]),
    DRAWER_STATE: {
      get() {
        return this.drawer;
      },
    },
    isMobile() {
      return navigator.userAgent.match(/Android/i) ||
        navigator.userAgent.match(/webOS/i) ||
        navigator.userAgent.match(/iPhone/i) ||
        navigator.userAgent.match(/iPod/i) ||
        navigator.userAgent.match(/iPad/i) ||
        navigator.userAgent.match(/BlackBerry/i)
        ? true
        : false;
    },
  },
  methods: {
    ...mapActions("trazabilidad", ["trazabilidadEstadoUsuarios"]),
    async buscarSala() {
      try {
        const datos = await db
          .collection("chatsdibujante")
          .where("uidcaso", "==", this.$route.params.id)
          .get();
        if (datos.empty && this.intento <= 3) {
          console.log(datos.empty, "crear sala");
          await this.crearChat();
          this.buscarSala();
          this.intento++;
          return;
        }
        const chat = await db
          .collection("chatsdibujante")
          .doc(datos.docs[0].id)
          .get();
        this.rooms = [{ ...chat.data() }];
        this.idchat = this.rooms[0].roomId;
        // console.log(this.currentUserId, "ID USUARIO");
        if (this.rooms[0].users.some((el) => el._id === this.currentUserId))
          return;
        // console.log("agregar usuarios");
        this.rooms[0].users.push({
          _id: this.currentUserId,
          username:
            this.logueado.nombres +
            this.logueado.identificacion.substr(0, 4) +
            "(" +
            this.logueado.cargo +
            ")",
          status: {
            state: "online",
          },
        });
        await db
          .collection("chatsdibujante")
          .doc(this.idchat)
          .update(this.rooms[0]);
      } catch (error) {
        this.handleError(error);
      }
    },
    // consulta los ms del chat anterior
    async buscarMensajes({ room, options }) {
      console.log(options);
      try {
        db.collection("mensajesdibujante")
          .where("roomId", "==", room.roomId)
          .onSnapshot((snap) => {
            let mensajes = snap.docs.map((e) => e.data());
            const msordenado = mensajes.sort((c1, c2) =>
              c1._id > c2._id ? 1 : c1._id < c2._id ? -1 : 0
            );
            this.messages = msordenado;
          });
        this.messagesLoaded = true;
      } catch (error) {
        this.handleError(error);
      }
    },
    async sendMessage({ content, roomId, files, replyMessage }) {
      this.messagesLoaded = false;
      try {
        if (!this.datosCaso.chat_dibujante)
          throw new Error("El chat ha sido bloqueado");
        if (files) {
          await this.cargarDocumentosChat(files);
        }
        if (replyMessage) {
          await this.responderMesanjes(replyMessage);
        }
        this.newMensaje.content = content;
        this.newMensaje.roomId = roomId;
        this.newMensaje._id = this.messages.length;
        this.newMensaje.indexId = this.messages.length;
        this.newMensaje.senderId = this.currentUserId;
        this.newMensaje.username =
          this.logueado.nombres +
          this.logueado.identificacion.substr(0, 4) +
          "(" +
          this.logueado.cargo +
          ")";
        this.newMensaje.date = moment().format("DD/MM/YYYY HH:mm", Date.now());
        this.newMensaje.timestamp = moment().format(
          "DD/MM/YYYY HH:mm",
          Date.now()
        );

        await db.collection("mensajesdibujante").add(this.newMensaje);
        // notificar a los usuarios que no estén conectados y que cuenten con token push
        await this.notificarMsj();
        this.newMensaje = {};
        this.messagesLoaded = true;
      } catch (error) {
        this.messagesLoaded = true;
        this.handleError(error);
      }
    },
    async notificarMsj() {
      this.usersTokenPush = [];
      this.mensajeChat = "";
      const { roomId, content: mensaje } = this.newMensaje;
      this.mensajeChat = mensaje;
      // console.log(roomId, mensaje);
      const objSala = await db
        .collection("chatsdibujante")
        .where("roomId", "==", `${roomId}`)
        .get();

      const infoSala = objSala.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      if (!infoSala) {
        return true;
      }

      const { users } = infoSala[0];
      const objUsers = users.filter((user) => user.status.state === "offline");
      //Usuarios
      const tokenUsuarios = await Promise.all(
        objUsers.map(async (u) => {
          const usuarios = await db.collection("usuarios").doc(u._id).get();
          if (usuarios.data()) {
            const { tokenPush } = usuarios.data();
            return tokenPush;
          }
        })
      );

      let usuDigipats = tokenUsuarios.filter((u) => u);

      if (usuDigipats) {
        this.usersTokenPush = [...this.usersTokenPush, ...usuDigipats];
      }

      // console.log(this.usersTokenPush);
      if (this.usersTokenPush) {
        await this.fechNotificaciones();
      }
    },
    async fechNotificaciones() {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      let registration_ids = this.usersTokenPush;
      if (registration_ids.length <= 0) {
        return;
      }
      //console.log(registration_ids);
      let message = this.mensajeChat;

      const dominio =
        process.env.VUE_APP_AMBIENTE === "sandbox"
          ? "https://sandbox.digipats.com.co"
          : "https://digipats.com.co";
      const ambiente =
        process.env.VUE_APP_AMBIENTE === "sandbox"
          ? process.env.VUE_APP_CLOUDFUNCTIONURL_SANDBOX
          : process.env.VUE_APP_CLOUDFUNCTIONURL;
      const url = `${ambiente}/enviarNotificacionFcm`;
      const raw = JSON.stringify({
        tokens: [...registration_ids],
        message: {
          notification: {
            title: "Mensaje Chat",
            body: message,
          },
          data: {
            url: `${dominio}/gestionar-caso/${this.idCaso}`,
          },
        },
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      await fetch(url, requestOptions)
        .then((response) => response.text())
        .then((result) => console.log(result))
        .catch((error) => console.log("error", error));
    },
    async cargarDocumentosChat(files) {
      const arrayDoc = [];
      const archivos = await Promise.all(
        files.map(async (file) => {
          file.nameArchivo = `${Date.now()}_${file.name}`;
          const storageRef = ref(storage, `DocChat/${file.nameArchivo}`);
          await uploadBytes(storageRef, file.blob);
          file.url = await getDownloadURL(
            ref(storage, `DocChat/${file.nameArchivo}`)
          );
          return file;
        })
      );
      if (archivos) {
        archivos.map((file, i) => {
          arrayDoc.push({
            name: `${file.nameArchivo}`,
            size: `${file.size}`,
            type: `${file.type}`,
            url: `${file.url}`,
            extension: `${file.extension} || ${file.type}`,
            preview: `${file.localUrl}`,
          });
          if (file.audio) {
            arrayDoc[i].audio = true;
            arrayDoc[i].duration = file.duration;
          }
        });
        this.newMensaje.files = arrayDoc;
      }
    },
    async responderMesanjes(replyMessage) {
      this.newMensaje.replyMessage = {
        _id: replyMessage._id,
        content: replyMessage.content,
        sender_id: replyMessage.senderId,
      };
      if (replyMessage.files) {
        this.newMensaje.replyMessage.files = replyMessage.files;
      }
    },
    async BloquearChat() {
      const swal = await this.$swal({
        title: `${
          this.datosCaso.chat_dibujante ? "Bloquear" : "Desbloquear"
        } Chat`,
        text: `¿Esta seguro?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Si",
        cancelButtonText: "No",
        cancelButtonColor: "#d33",
      });
      if (swal.isConfirmed) {
        db.collection("casos")
          .doc(this.idCaso)
          .update({ chat_dibujante: !this.datosCaso.chat_dibujante })
          .then(() => {
            // TODO: falta por probar, liberar el perito del caso
            this.actualizarEstadoAgente();
            this.$swal({
              icon: "success",
              title: "Bien",
              text: "Operación Exitosa",
            });
          });
      }
    },
    async actualizarEstadoAgente() {
      // consultamos la cantidad de caso en los que esta asociado para determinar el estado
      db.collection("casos")
        .where("uiddibujante", "==", this.datosCaso.uiddibujante)
        .where("archivado", "==", false)
        .where("estado", "not-in", ["Cancelado", "Conciliado", "No conciliado"])
        .get()
        .then((res) => {
          this.estadoAgente =
            res.size > 1 ? "Activo multiple" : "Activo ocupado";
          // se actualiza el estado del usuario logueado
          db.collection("usuarios")
            .doc(this.datosCaso.uiddibujante)
            .update({ disponibilidad: this.estadoAgente })
            .then(() => {
              this.trazabilidadEstadoUsuarios({
                descripcion: `Dibujante ${
                  this.datosCaso.chat_dibujante
                    ? "asociado nuevamente al "
                    : "liberado del "
                } caso # ${this.datosCaso.caso}`,
                estado: this.estadoAgente,
                uidcaso: this.idCaso,
                cargo: "Dibujante",
                uidcreador: this.logueado.id,
                uidusuario: this.datosCaso.uiddibujante,
              });
            });
        });
    },
    openFile({ file }) {
      try {
        const extension = ["pdf", "docx", "doc", "xlsx", "xls"];
        if (
          this.logueado.cargo == "Dibujante" ||
          this.logueado.cargo == "Administrador" ||
          this.logueado.cargo == "Coordinador Investigador" ||
          this.logueado.cargo == "Investigador"
        ) {
          if (extension.includes(file.file.extension))
            window.open(file.file.url, "_blank");
          if (!extension.includes(file.file.extension))
            this.descargarImagen(file.file.url);
        } else {
          throw new Error(
            "Su rol no esta  autorizado para realizar esta acción"
          );
        }
      } catch (error) {
        this.handleError(error);
      }

      // window.open(file.file.url, "_blank");
    },
    descargarImagen(imageUrl) {
      fetch(imageUrl)
        .then((response) => {
          if (!response.ok) {
            throw new Error(
              "Error al descargar la imagen: " +
                response.status +
                " " +
                response.statusText
            );
          }
          return response.blob();
        })
        .then((blob) => {
          saveAs(blob, "imagen.jpg");
        })
        .catch((error) => {
          console.error("Error al descargar la imagen:", error);
        });
    },
    handleError({ message }) {
      this.$swal({ icon: "error", title: "Oops...", text: message });
      this.loading = false;
    },
    async crearChat() {
      try {
        // console.log("crear chat");
        // eslint-disable-next-line
        // this.crearChat.avatar =
        //"https://firebasestorage.googleapis.com/v0/b/servdigipats.appspot.com/o/foto-perfil%2Flogo.png?alt=media&token=ac1de4f6-5fb5-4326-a944-4baaf85c46a9";
        this.crearChat.avatar =
          "https://firebasestorage.googleapis.com/v0/b/servdigipats.appspot.com/o/foto-perfil%2Fvml.ico?alt=media&token=d93de8fc-dc76-4c53-bb6e-f8420d814827";
        this.crearChat.roomName = "Chat en proceso (Entrar)";
        this.crearChat.uidcaso = this.$route.params.id;
        this.crearChat.unreadCoun = 0;
        this.crearChat.users = [];
        // console.log(this.crearChat, "chat");
        const resChat = await db
          .collection("chatsdibujante")
          .add(this.crearChat);
        await db
          .collection("chatsdibujante")
          .doc(resChat.id)
          .update({ roomId: resChat.id });
        await db
          .collection("casos")
          .doc(this.$route.params.id)
          .update({ solicitud_dibujante: true, chat_dibujante: true });
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
<style scoped>
#infinite-loader-rooms {
  display: none;
}
</style>
